import { render, staticRenderFns } from "./PersonalAccountPanel.vue?vue&type=template&id=fcd4b7c8"
import script from "./PersonalAccountPanel.vue?vue&type=script&lang=js"
export * from "./PersonalAccountPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports